export enum Product {
  PAGE_SIZE = 20,
  CARD = 'card',
  ROW = 'row',
  ICON = 'icon',
  TEXT = 'text',
  VIEW = 'view',
}
